import React from 'react';
import PropTypes from 'prop-types';

/**
 * Menu - A wrapper that renders a standard HTML nav element with Bulma menu class names
 * 
 * This component accepts the same props as Bloomer Menu for easy migration
 */
const Menu = ({
  className,
  style,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['menu'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <nav 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </nav>
  );
};

Menu.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

Menu.defaultProps = {
  className: '',
  style: {},
  children: null
};

export default Menu;
